<template>
  <ShowVehicleCommentModal/>
  <ShowTrailerCommentModal/>
  <SelectTrailerParkingModal/>
  <button
    type="button"
    class="btn btn-primary btn-floating btn-lg"
    id="btn-back-to-top"
    ref="mybutton"
    @click="backToTop"
  >
    <i class="fas fa-arrow-up"></i>
  </button>
  <Navbar/>
  <NiceLoader style="display: none;"></NiceLoader>
  <div class="p-4">
    <div class="d-flex mb-4 text-darker justify-content-evenly">
      <div>
        <a href="#" class="text-secondary text-decoration-none" @click="isSearchVisible = !isSearchVisible">
          <i class="fas fa-search"></i>
          <span v-show="isSearchVisible" @click="searchText = '';fetchVehicles()">Zamknij wyszukiwanie</span>
          <span v-show="!isSearchVisible">Szukaj</span>
        </a>
        <div v-show="isSearchVisible">
          <input v-model="searchText" type="search" class="form-control" ref="searchInput" placeholder="Wyszukaj w panelu" @input="searchFn()">
        </div>
      </div>
      <RefreshButton :refreshing="refreshing"/>
    </div>
    <hr>
    <div class="row py-3">
      <div class="d-lg-flex justify-content-between">
        <h5 class="fw-bold">
          MAGAZYN
        </h5>
        <div class="d-flex justify-content-between my-4">
          <router-link :to="{ name: 'CreateTrailer' }" class="fit-content btn btn-primary me-4">
            Dodaj naczepę
          </router-link>

          <router-link :to="{ name: 'ParkingList' }" class="btn btn-primary fit-content">
            Parkingi
          </router-link>

          <router-link :to="{ name: 'TrailersByParkings' }" class="ms-4 btn btn-primary fit-content">
            Parkingi z naczepami
          </router-link>
        </div>

        <div>
          <ActiveCounter :vehicles="vehicles" :trailers="trailers" :drivers="[]"/>
        </div>

        <div class="mt-3 mt-lg-0">
          <select class="form-select" v-model="filterType" ref="selectType" @change="filterStorehouse">
            <option :value="null">Pokaż wszystkie pojazdy</option>
            <option value="vehicles">Pokaż ciągniki</option>
            <option value="trailers">Pokaż naczepy</option>
          </select>

          <select class="form-select mt-2" v-model="sortMode" @change="fetchTrailers">
            <option :value="null" disabled>--- Wybierz opcję sortowania naczep ---</option>
            <option value="1">Sortowanie według nazw parkingów</option>
            <option value="2">Sortuj według nazw naczep/ciągników</option>
          </select>
        </div>

      </div>

    </div>
    <table class="table table-responsive overflow-scroll" style="min-width: 1200px;">
      <thead>
      <tr>
        <td class="bg-light p-2 rounded border border-white" style="width: 200px;">
          Nazwa
        </td>
        <td class="bg-light p-2 rounded border border-white" style="width: 200px;">
          Typ
        </td>
        <td class="bg-light p-2 rounded border border-white" style="width: 200px;">
          Status
        </td>
        <td class="bg-light p-2 rounded border border-white" style="width: 200px;">
          Parking
        </td>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(vehicle, index) in filteredVehicles.length > 0 ? filteredVehicles : vehicles" :key="vehicle.id">
        <td style="width: 200px;" v-if="filteredTrailers.length === 0 && !restrictedVehicles.includes(vehicle.plateNumber)">
          <VehicleCell :mailings="mailings" :vehicle="vehicle" :index="index" @Refetch="fetchVehicles()" />
        </td>
        <td style="width: 200px;" v-if="filteredTrailers.length === 0 && !restrictedVehicles.includes(vehicle.plateNumber)">
          <VehicleType type="Ciągnik"/>
        </td>
        <td style="width: 200px;" v-if="filteredTrailers.length === 0 && !restrictedVehicles.includes(vehicle.plateNumber)">
          <StatusCell :vehicle="vehicle"/>
        </td>
        <td style="width: 200px;" v-if="filteredTrailers.length === 0 && !restrictedVehicles.includes(vehicle.plateNumber)">
          <div class="p-2 text-left bg-white fw-bold rounded border border-white">
            <div class="d-flex justify-content-between">
              <div class="mt-0">
                <div class="text-sm-secondary">
                  Testowy
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
      <tr v-for="trailer in filteredTrailers.length > 0 ? filteredTrailers : trailers" :key="trailer.id">
        <td style="width: 200px;" v-if="filteredVehicles.length === 0">
          <TrailerCell :trailer="trailer" :key="trailer.id"/>
        </td>
        <td style="width: 200px;" v-if="filteredVehicles.length === 0">
          <VehicleType type="Naczepa"/>
        </td>
        <td style="width: 200px;" v-if="filteredVehicles.length === 0">
          <StatusCell :vehicleStatus="trailer.parking ? 'W magazynie': 'W trasie'" :vehicle="trailer"/>
        </td>
        <td style="width: 200px;" v-if="filteredVehicles.length === 0">
          <div class="p-2 text-left bg-white fw-bold rounded border border-white">
            <div class="d-flex justify-content-between">
              <div class="mt-0">
                <router-link :to="{ name: 'EditParking', params: { id: trailer.parking.id } }" class="btn text-sm-secondary" v-if="trailer.parking">
                  {{ trailer.parking.name }}
                </router-link>
                <div class="text-sm-secondary" v-else>
                  Brak parkingu
                </div>
              </div>
            </div>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar'
import VehicleCell from '@/components/VehicleCell'
import VehicleType from '@/components/VechicleType'
import StatusCell from '@/components/StatusCell'
import TrailerCell from '@/components/StorehouseListing/TrailerCell'
import { $axios } from '@/modules/http/axios'
import axios from 'axios'
import NiceLoader from '../../components/niceLoader.vue'
import emitter from '@/modules/events/emitter'
import RefreshButton from '@/components/Layout/RefreshButton.vue'
import restrictedVehicles from '@/modules/vehicles/restricted'
import eventKinds from '@/modules/events/eventKinds'
import ActiveCounter from '@/components/Partials/Statistics/ActiveCounter.vue'
import ShowVehicleCommentModal from '@/components/TasksCalendar/Modals/ShowVehicleCommentModal.vue'
import ShowTrailerCommentModal from '@/components/TasksCalendar/Modals/ShowTrailerCommentModal.vue'
import SelectTrailerParkingModal from '@/components/TasksCalendar/Modals/SelectTrailerParkingModal.vue'

export default {
  name: 'StorehouseListing',
  components: { SelectTrailerParkingModal, ShowTrailerCommentModal, ShowVehicleCommentModal, ActiveCounter, RefreshButton, StatusCell, VehicleType, VehicleCell, Navbar, TrailerCell, NiceLoader },
  data () {
    return {
      filterType: null,
      isSearchVisible: false,
      searchText: '',
      vehicles: [],
      trailers: [],
      filteredVehicles: [],
      filteredTrailers: [],
      mailings: null,
      sortMode: null,
      refreshing: false,
      restrictedVehicles: [],
      controller: new AbortController()
    }
  },
  created () {
    this.getMailing()
    this.$store.commit('setInitialCalendarLoading', true)
    window.addEventListener('scroll', this.scrollFunction)

    emitter.on(eventKinds.calendarShown, () => {
      this.controller.abort()
    })
    emitter.on(eventKinds.tasksListShown, () => {
      this.controller.abort()
    })
    emitter.on(eventKinds.driverListingShown, () => {
      this.controller.abort()
    })
    emitter.on(eventKinds.placesShown, () => {
      this.controller.abort()
    })
    emitter.on(eventKinds.reportsShown, () => {
      this.controller.abort()
    })
    emitter.on(eventKinds.usersShown, () => {
      this.controller.abort()
    })

    emitter.on('refreshed', this.refresh)
    emitter.on('countersReady', this.refresh)
    emitter.on('trioCommentModified', this.fetchVehicles)
    emitter.on('vehicleChanged', this.fetchVehicles)
    emitter.on('trailerCommentAdded', e => this.reFetchTrailer(e.trailerId))
  },
  methods: {
    refresh () {
      this.refreshing = true
      this.fetchVehicles()
      this.fetchTrailers()

      if (this.filterType) {
        this.filterStorehouse()
      }

      if (this.searchText !== '') {
        this.searchFn()
      }

      setTimeout(() => {
        this.refreshing = false
      }, 1000)
    },

    async fetchVehicles () {
      const axiosConfig = {
        headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` },
        signal: this.controller.signal
      }

      this.filteredVehicles = []
      this.filteredTrailers = []

      try {
        this.vehicles = (await axios.get(`${process.env.VUE_APP_API_BASE_URL}Vehicle`, axiosConfig)).data
      } catch (e) {
        console.log(e)
      }
    },
    async fetchTrailers () {
      try {
        this.trailers = (await $axios.get('Trailer')).data
        this.sortTrailers()
      } catch (e) {
        console.log(e)
      }
    },

    async reFetchTrailer (trailerId) {
      const updatedTrailer = (await $axios.get(`Trailer/${trailerId}`)).data

      this.trailers.map(async (trailerFromCollection, index) => {
        if (trailerFromCollection.id === trailerId) {
          this.trailers[index] = updatedTrailer
        }
      })

      this.filterType = 'trailers'
      await this.filterStorehouse()
    },

    sortTrailers () {
      // eslint-disable-next-line eqeqeq
      if (this.sortMode == 2) {
        this.trailers = this.trailers.sort((a, b) => {
          var textA = a.plateNumber.toUpperCase()
          var textB = b.plateNumber.toUpperCase()
          return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
        })
      } else {
        this.trailers = this.trailers.sort(function (a, b) {
          if (a.parking === null) { return 1 }
          if (b.parking === null) { return -1 }

          if (a.parking.name < b.parking.name) { return -1 }
          if (a.parking.name > b.parking.name) { return 1 }
          return 0
        })
      }
    },
    async filterStorehouse () {
      if (this.filterType === 'vehicles') {
        this.vehicles = (await $axios.get('Vehicle')).data
        this.trailers = []
      }

      if (this.filterType === 'trailers') {
        this.trailers = (await $axios.get('Trailer')).data
        this.vehicles = []

        this.sortTrailers()
      }

      if (this.filterType === null) {
        this.vehicles = (await $axios.get('Vehicle')).data
        this.trailers = (await $axios.get('Trailer')).data

        this.sortTrailers()
      }
    },
    scrollFunction () {
      if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        if (this.$refs.mybutton !== null) {
          this.$refs.mybutton.style.display = 'block'
        }
      } else {
        if (this.$refs.mybutton !== null) {
          this.$refs.mybutton.style.display = 'none'
        }
      }
    },
    backToTop () {
      document.body.scrollTop = 0
      document.documentElement.scrollTop = 0
    },
    getMailing () {
      $axios.get('NotificationRecipient')
        .then(response => {
          this.mailings = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    searchFn () {
      const selectType = this.$refs.selectType.value
      const searchText = this.searchText.trim()

      setTimeout(() => {
        switch (selectType) {
          case 'Pokaż wszystkie pojazdy':
            this.filteredVehicles = this.vehicles.filter(vehicle => vehicle.plateNumber.toLowerCase().includes(searchText.toLowerCase()));
            this.filteredTrailers = this.trailers.filter(trailer => trailer.plateNumber.toLowerCase().includes(searchText.toLowerCase()));
            break
          case 'vehicles':
            this.filteredVehicles = this.vehicles.filter(vehicle => vehicle.plateNumber.toLowerCase().includes(searchText.toLowerCase()));
            break
          case 'trailers':
            this.filteredTrailers = this.trailers.filter(trailer => trailer.plateNumber.toLowerCase().includes(searchText.toLowerCase()));
            break
        }
      }, 1000)
    }
  }
}
</script>

<style scoped>
#btn-back-to-top {
  position: fixed;
  bottom: 20px;
  right: 20px;
  display: none;
}
.text-sm-secondary {
  font-size: .6rem;
}

.fit-content {
  height: fit-content;
}
</style>
